import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { QMPunkte } from "@/components/qm/QMPunkte";
import { QMKennzahlen } from "@/components/qm/QMKennzahlen";
import { QMBeschwerden } from "@/components/qm/QMBeschwerden";
import { QMDokumente } from "@/components/qm/QMDokumente";
import { QMFeststellungen } from "@/components/qm/QMFeststellungen";
import { QMAuditorPaket } from "@/components/qm/QMAuditorPaket";

const TABS = [["punkte", "Offene Punkte", QMPunkte], ["kennzahlen", "Kennzahlen", QMKennzahlen], ["beschwerden", "Beschwerden", QMBeschwerden],
  ["dokumente", "QM-Dokumente", QMDokumente], ["feststellungen", "Audit-Feststellungen", QMFeststellungen], ["auditor", "Auditor-Paket", QMAuditorPaket]];

export default function QMCockpit() {
  return (
    <div className="p-6 lg:p-8 max-w-7xl" data-testid="qm-cockpit">
      <p className="text-[11px] uppercase tracking-[0.2em] text-[#9A3B2E] font-semibold">AZAV &amp; Qualitätsmanagement</p>
      <h1 className="text-3xl font-semibold mt-1 mb-5">QM-Cockpit</h1>
      <Tabs defaultValue="punkte">
        <TabsList className="flex flex-wrap h-auto mb-4">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`qm-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
